import { Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMultiUpdateFieldPrompt extends Layout {
    switchFieldValue: Switch;
    textboxField: Textbox;
    textboxFieldValue: Textbox;
}
